import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DfCatalogUiModule } from '@df/catalog-ui/df-catalog-ui.module';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content';
import { CmsBlogPostComponent } from '../../../../../cms/blog/post/cms-blog-post.component';
import { CustomCursorComponent } from '../../../../../ui/display/custom-cursor/custom-cursor.component';
import { CategoryComponent } from '../../../category/category.component';
import { ProductComponent } from '../../../product/product.component';
import { addBloomreachRecommendationsVariant } from '../bloomreach-recommendations/bloomreach-recommendations.config';
import { IBloomreachRecommendationsOptions } from '../bloomreach-recommendations/bloomreach-recommendations.interface';
import { ILocalModelCarouselV2Data } from '../local-model-carousel-v2/local-model-carousel-v2.interface';
import { LocalModelCarouselV2Component } from './../local-model-carousel-v2/local-model-carousel-v2.component';
import { getFields } from './../local-model-carousel-v2/local-model-carousel-v2.config';

interface ILocalProductCarouselV2Data extends ILocalModelCarouselV2Data, IBloomreachRecommendationsOptions {}

@Component({
    selector: 'page-component-product-carousel-v2',
    templateUrl: './../local-model-carousel-v2/local-model-carousel-v2.html',
    styleUrl: './../local-model-carousel/local-model-carousel.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CategoryComponent,
        CmsBlogPostComponent,
        CommonModule,
        CustomCursorComponent,
        DfCatalogUiModule,
        DfImageDirective,
        DfImageWrapperComponent,
        GtmTrackViewItemListDirective,
        GridModule,
        HrefComponent,
        ICmsClientModule,
        InfiniteScrollDirective,
        forwardRef(() => ProductComponent),
        RouterModule,
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentProductCarouselV2Component>({
    id: 'product-carousel-v2',
    name: 'Product Carousel (Variant 2)',
    image: 'assets/images/cms/product-carousel-v2.png',
    description: 'Editorial carousel (without loop)',
    tags: ['images', 'carousel', 'slider', 'product'],
    fields: addBloomreachRecommendationsVariant(getFields(Product.type))
})
export class PageComponentProductCarouselV2Component extends LocalModelCarouselV2Component<
    Product<IProductDataV2>,
    ILocalProductCarouselV2Data
> {
    type = Product.type;
}
